/**
 * This file contains the sets of features that are available to each tier to be used for access gating.
 * These are not defined on the FeatureFlags themselves since we are going to gate certain features based on the
 * organization's tier, so we won't be **only** checking for FeatureFlags here.
 */
import {
  FULL_QUALITY,
  FULL_SECURITY,
  LDAP_AUTHENTICATION,
  QUALITY,
  SBOM_PORTAL,
  SECURITY,
} from '../featureFlags/flagNames';
import type { FossaPlanName } from './consts';
import {
  ENTERPRISE_COMPLIANCE,
  ENTERPRISE_PLATFORM,
  ENTERPRISE_RELEASE_MANAGEMENT,
  FREE_PLAN_NAME,
  LEGACY_PREMIUM_PLAN_1,
  LEGACY_PREMIUM_PLAN_2,
  PREMIUM_COMP_SEC_PLAN_NAME,
  PREMIUM_COMPLIANCE_PLAN_NAME,
  PREMIUM_PER_REVISION_PLAN_NAME,
} from './consts';
import type { FlagName } from '../featureFlags/types';

const baseEnterpriseFeatures: FlagName[] = [LDAP_AUTHENTICATION, SBOM_PORTAL];

export const TIER_FEATURE_MAP: Partial<Record<FossaPlanName, Set<FlagName>>> = {
  [FREE_PLAN_NAME]: new Set<FlagName>([
    QUALITY,
    SBOM_PORTAL,
    SECURITY,
  ]),
  [LEGACY_PREMIUM_PLAN_1]: new Set([
    QUALITY,
    SBOM_PORTAL,
    SECURITY,
  ]),
  [LEGACY_PREMIUM_PLAN_2]: new Set([
    QUALITY,
    SBOM_PORTAL,
    SECURITY,
  ]),
  [PREMIUM_COMPLIANCE_PLAN_NAME]: new Set([
    QUALITY,
    SBOM_PORTAL,
    SECURITY,
  ]),
  [PREMIUM_COMP_SEC_PLAN_NAME]: new Set([
    FULL_SECURITY,
    QUALITY,
    SBOM_PORTAL,
    SECURITY,
  ]),
  [PREMIUM_PER_REVISION_PLAN_NAME]: new Set([
    FULL_QUALITY,
    FULL_SECURITY,
    QUALITY,
    SBOM_PORTAL,
    SECURITY,
  ]),
  [ENTERPRISE_COMPLIANCE]: new Set(baseEnterpriseFeatures),
  [ENTERPRISE_PLATFORM]: new Set([
    ...baseEnterpriseFeatures,
    FULL_QUALITY,
    FULL_SECURITY,
    QUALITY,
    SECURITY,
  ]),
  [ENTERPRISE_RELEASE_MANAGEMENT]: new Set([
    ...baseEnterpriseFeatures,
    FULL_QUALITY,
    FULL_SECURITY,
    QUALITY,
    SECURITY,
  ]),
};

/**
 * This set is used to decide whether or not the FeatureManager needs look up an org to get its stripe plan before
 * checking the tierFeatures map. This include features that are enabled for enterprise and the dynamic stripe plans.
 */
export const TIER_SPECIFIC_FEATURES = new Set([
  LDAP_AUTHENTICATION,
  SBOM_PORTAL,
  SECURITY,
  QUALITY,
  FULL_SECURITY,
  FULL_QUALITY,
]);
